import React, { useState } from 'react';


export default function VoucherPurchaseForm({ onCreate, busy }) {
  const [form, setForm] = useState({
    name: '',
    surname: '',
    secondSurname: '',
    phone: '',
    email: '',
    hoursPurchased: 10,
  });

  function updateField(name, value) {
    setForm((previous) => ({
      ...previous,
      [name]: value,
    }));
  }

  function handleSubmit(event) {
    event.preventDefault();
    onCreate({
      ...form,
      surname: [form.surname, form.secondSurname].filter(Boolean).join(' ').trim(),
      hoursPurchased: Number(form.hoursPurchased),
    });
  }

  return (
    <form onSubmit={handleSubmit} className="rounded-[30px] border border-[var(--app-border)] bg-[var(--app-surface)] p-6 space-y-5 shadow-[0_24px_60px_rgba(15,23,42,0.05)] backdrop-blur-xl">
      <div className="space-y-2">
        <p className="text-[11px] uppercase tracking-[0.32em] text-slate-400">Venta nueva</p>
        <h3 className="text-3xl font-semibold tracking-[-0.04em] text-slate-950">Crear bono</h3>
      </div>

      <div className="grid gap-4 lg:grid-cols-2">
        <input
          type="text"
          value={form.name}
          onChange={(event) => updateField('name', event.target.value)}
          placeholder="Nombre"
          className="app-input"
        />
        <input
          type="text"
          value={form.surname}
          onChange={(event) => updateField('surname', event.target.value)}
          placeholder="Primer apellido"
          className="app-input"
        />
        <input
          type="text"
          value={form.secondSurname}
          onChange={(event) => updateField('secondSurname', event.target.value)}
          placeholder="Segundo apellido opcional"
          className="app-input"
        />
        <input
          type="tel"
          value={form.phone}
          onChange={(event) => updateField('phone', event.target.value)}
          placeholder="Número móvil"
          className="app-input"
        />
        <input
          type="email"
          value={form.email}
          onChange={(event) => updateField('email', event.target.value)}
          placeholder="Email opcional"
          className="app-input"
        />
      </div>

      <div className="grid gap-4 lg:grid-cols-[180px_1fr] lg:items-center">
        <input
          type="number"
          min="1"
          step="1"
          value={form.hoursPurchased}
          onChange={(event) => updateField('hoursPurchased', event.target.value)}
          className="app-input text-2xl font-semibold"
        />
        <button
          type="submit"
          disabled={busy}
          className="rounded-[22px] bg-[#0a84ff] hover:bg-[#0077ed] text-white py-4 text-lg font-semibold shadow-[0_16px_28px_rgba(10,132,255,0.18)] disabled:opacity-50"
        >
          {busy ? 'Creando bono...' : 'Crear titular y bono'}
        </button>
      </div>
    </form>
  );
}
